import { CouponUseTypes } from '../const.js';

/**
 *
 * @param {Array} orderedDishes 菜品列表
 * @param {Object} priv 优惠劵|优惠规则
 * @param {String} typeName
 */
export function getCanUsePrivDishes(orderedDishes, priv, typeName = 'dishConditionType') {
  if (!priv || !orderedDishes || !orderedDishes.length) {
    return [];
  }

  const { dishList, [typeName]: dishConditionType } = priv;
  if (dishConditionType === CouponUseTypes.ALL) {
    return orderedDishes;
  }

  const operedDishes = dishList.reduce((acc, cur) =>
    [cur.dishId]
      .concat((cur.dishList || []).map(item => item.dishId))
      .filter(id => !!id)
      .reduce((obj, key) => {
        obj[key] = true;
        return obj;
      }, acc), {});

  const part = dishConditionType === CouponUseTypes.PART;
  return orderedDishes.filter(dish => !!operedDishes[dish.brandDishId] === part);
}



// WEBPACK FOOTER //
// ./src/helper/privilege/common.js